export const environment = {
  apiUri:
    (process.env.NODE_ENV === "development"
      ? `${window.location.origin}`
      : "") + process.env.VUE_APP_API_URL,
};
